import toast from "./toast";
import * as XLSX from "xlsx";

export default {
	mixins: [toast],
	props: {
		showPreviewVideo: {
			type: Boolean,
			default: false,
		},
		fileTypes: {
			type: String,
			default: ".png, .jpg, .jpeg",
		},
		maxSizeInBytes: {
			type: Number,
			default: 20 * 1024 * 1024,
		},
	},
	methods: {
		// uploadFile(file) {
		// 	if (file.size > this.maxSizeInBytes) {
		// 		this.errorToast("Uploaded file exceeds size");
		// 		return;
		// 	}
		// 	const fileExtension = file.name.split(".").pop().toLowerCase();

		// 	if (!this.fileTypes.includes(fileExtension)) {
		// 		this.errorToast("Invalid file type");
		// 		return;
		// 	}

		// 	if (this.isVideo(fileExtension)) {
		// 		this.$emit("file-selected", file);
		// 		console.log(file, "file");
		// 	} else {
		// 		const fileData = {};
		// 		fileData.fileName = file.name;
		// 		fileData.size = file.size;
		// 		var reader = new FileReader();
		// 		reader.readAsDataURL(file);
		// 		fileData.sourceKey = file;
		// 		console.log(fileData, "file data");

		// 		reader.onload = (event) => {
		// 			fileData.previewKey = event.target.result;
		// 			this.$emit("file-selected", fileData);
		// 		};
		// 	}
		// },
		uploadFile(file) {
			if (file.size > this.maxSizeInBytes) {
				this.errorToast("Uploaded file exceeds size");
				return;
			}
			const fileExtension = file.name.split(".").pop().toLowerCase();

			if (!this.fileTypes.includes(fileExtension)) {
				this.errorToast("Invalid file type");
				return;
			}

			const fileData = {};
			fileData.fileName = file.name;
			fileData.size = file.size;
			fileData.sourceKey = file;

			if (this.isVideo(fileExtension)) {
				const videoPreviewUrl = URL.createObjectURL(file);
				fileData.videoPreviewKey = videoPreviewUrl;
				fileData.previewKey = videoPreviewUrl;
				if (this.showPreviewVideo) {
					this.$emit("file-selected", fileData);
				} else {
					this.$emit("file-selected", file);
				}
			} else {
				var reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = (event) => {
					fileData.previewKey = event.target.result;
					this.$emit("file-selected", fileData);
					console.log(fileData, "image file data");
				};
			}
		},

		isVideo(fileExtension) {
			const videoExtensions = ["mp4", "mov", "webm"];
			return videoExtensions.includes(fileExtension);
		},

		uploadExcelFile(file) {
			const fileData = {};
			fileData.fileName = file.name;
			var reader = new FileReader();
			reader.readAsArrayBuffer(file);
			fileData.sourceKey = file;
			reader.onload = (event) => {
				const data = new Uint8Array(event.target.result);
				const workbook = XLSX.read(data, { type: "array" });
				const newSheets = workbook.SheetNames.map((name, i) => ({
					value: i + 1,
					text: name,
				}));

				fileData.sheets = newSheets;
				fileData.items = [...newSheets];
				this.$emit("file-selected", fileData);
			};
		},
	},
};
